module.exports = __webpack_public_path__ + "static/media/281.76e4d22e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/281.jpg
// module id = 971
// module chunks = 0